// @flow
import alert from './assets/alert.svg';
import flyer from './assets/flyer.svg';
import nearbyWalker from './assets/nearby-walker.svg';
import oneShelter from './assets/one-shelter.svg';
import support from './assets/customer-support.svg';
import threeShelter from './assets/three-shelter.svg';
import twoShelter from './assets/two-shelter.svg';

export const icons = {
  alert,
  flyer,
  nearbyWalker,
  oneShelter,
  support,
  threeShelter,
  twoShelter,
};
